
export const createAddressPayload = (payload) => {
  const attributes = {
    "city": payload.townName || '',
    "street": payload.streetName || '.',
    "reference": payload.reference || "",
    "node": payload?.buildingId?.id || payload?.locationsData?.buildings?.[0]?.buildings?.zonaID || "1",
    "latitude": payload.locationDetails.location.latitude,
    "longitude": payload.locationDetails.location.longitude,
    "state": payload?.buildingId?.estadoID ? payload?.buildingId?.estadoID : "",
    "country": "Bolivia",
    "id": "1",
    "neighborhood": "",
    "zipcode": "",
    "comments": `${payload?.buildingId?.name? `${payload?.buildingId?.name} |` : ''} ${payload?.townName || ''} ${payload?.reference || ''}`?.trim()
  }


  return {
    "leadStep": 2,
    "activateService": {
      "createCustomerMutation": {
        "individualsCreateMutation": {
          "included": {
            "newInstance": {
              "included": {
                "distributor": "",
                "locations": [
                  {
                    "attachment": {
                      "description": "",
                      "photo": ""
                    },
                    attributes
                  }
                ],
                "scoreValidation": {
                  "hasDebt": "",
                  "qualificationScore": ""
                },
                "vendor": ""
              }
            }
          }
        }
      },
      "workOrder": {
        "included": {
          "newInstance": {
            "attributes": {
              "dateTime": {
                "end": "",
                "start": ""
              }
            }
          }
        }
      }
    }
  }
}